import accountService from "./../../services/account";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import store from "./../../store";
import Vue from "vue";
import webSiteService from "../../services/website";

export default {
  store,
  data() {
    return {
      en: en,
      fr: fr,
      loading: true,
      language: localStorage.getItem("lang") || "fr",
      checkinDate: "",
      checkoutDate: "",
      rentals: [],
      dataToSend: {
        startDate: this.$route.query.startDate || "",
        endDate: this.$route.query.endDate || "",
        adultsNumber: this.$route.query.adultsNumber || 1,
        childrenNumber: this.$route.query.childrenNumber || 0,
        guestNumber: this.$route.query.guestNumber || 1,
        webKey: "",
        groupIds: [],
        groupNames: this.$route.query.groups || "",
      },
      startDate: {},
      endDate: {},
      website_settings: {},
      lang: this.$route.query.lang || "fr",
      rentalGroups: [],
      diffDays: 1,
    };
  },
  components: {
    Datepicker,
    VLoading: require("components/loading/loading.vue"),
  },
  async mounted() {
    this.dataToSend.webKey = this.$route.params.webKey;
    if (!this.$route.query.adultsNumber) {
      this.dataToSend.adultsNumber =
        this.$route.query.guestNumber > 0 ? this.$route.query.guestNumber : 1;
    } else {
      this.dataToSend.adultsNumber =
        this.dataToSend.adultsNumber > 0 ? this.dataToSend.adultsNumber : 1;
    }
    this.dataToSend.childrenNumber =
      this.dataToSend.childrenNumber > 0 ? this.dataToSend.childrenNumber : 0;
    Vue.config.lang = this.lang;
    await webSiteService.getGroupsWithRentals(this, this.dataToSend.webKey);
    await this.checkSelectedGroups();
    await accountService.getUserRentals(this, this.dataToSend);

    if (this.website_settings && this.website_settings.custom_style) {
      const customStyleHead = document.getElementsByTagName("head")[0];
      const customStyle = document.createElement("style");
      customStyle.type = "text/css";
      customStyle.innerText = this.website_settings.custom_style;
      customStyleHead.appendChild(customStyle);
    }
    this.loading = false;
    if (this.website_settings) {
      if (this.website_settings.google_pixel_head) {
        const text = this.website_settings.google_pixel_head.match(
          /<script>([\s\S]*?)<\/script>/
        );

        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        if (text) {
          script.innerText = text[1];

          head.appendChild(script);
        }
      }

      if (this.website_settings.google_pixel_body) {
        const text = this.website_settings.google_pixel_body.match(
          /<script>([\s\S]*?)<\/script>/
        );
        const body = document.getElementsByTagName("body")[0];
        const script = document.createElement("script");
        if (text) {
          script.innerText = text[1];
          body.appendChild(script);
        }
      }
    }
  },
  methods: {
    searchData() {
      this.loading = true;
      const formattedStart =
        this.dataToSend.startDate === ""
          ? this.dataToSend.startDate
          : moment(this.dataToSend.startDate, "YYYY-MM-DD").format(
              "YYYY-MM-DD"
            );
      const formattedEnd =
        this.dataToSend.endDate === ""
          ? this.dataToSend.endDate
          : moment(this.dataToSend.endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
      accountService.getUserRentals(this, this.dataToSend);
      const queryData = {
        startDate: formattedStart,
        endDate: formattedEnd,
        adultsNumber: this.dataToSend.adultsNumber,
        childrenNumber: this.dataToSend.childrenNumber,
        lang: this.lang,
      };
      if (this.dataToSend.groupNames) {
        queryData.groups = this.dataToSend.groupNames;
      }
      this.$router.replace({
        name: "rental.availabilities",
        query: queryData,
      });
    },
    incOrDecGuestCount: function (sign, isChild = false) {
      this.dataToSend.childrenNumber = parseInt(this.dataToSend.childrenNumber);
      this.dataToSend.adultsNumber = parseInt(this.dataToSend.adultsNumber);
      if (sign === "+") {
        if (isChild) {
          this.dataToSend.childrenNumber++;
        } else {
          this.dataToSend.adultsNumber++;
        }
      } else {
        if (isChild) {
          if (this.dataToSend.childrenNumber === 0) {
            return;
          }
          this.dataToSend.childrenNumber--;
        } else {
          if (this.dataToSend.adultsNumber === 1) {
            return;
          }
          this.dataToSend.adultsNumber--;
        }
      }
    },
    filterByGroups() {
      let checkedGroupNames = [];
      this.rentalGroups.forEach((group) => {
        if (group.checked) {
          checkedGroupNames = [...checkedGroupNames, group.name];
        }
      });

      this.dataToSend.groupNames =
        checkedGroupNames.length > 0 ? [...checkedGroupNames] : "";
    },
    checkSelectedGroups() {
      const groupNames = this.dataToSend.groupNames;
      const groupsData = [...this.rentalGroups];
      groupsData.forEach((group) => {
        if (groupNames.includes(group.name)) {
          group.checked = true;
        }
      });
      this.rentalGroups = [...groupsData];
    },
    correctDatePickerDates(newDate, type = "start") {
      if (this.dataToSend.startDate >= this.dataToSend.endDate) {
        if (type === "start") {
          this.dataToSend.endDate = moment
            .utc(newDate)
            .add(this.diffDays, "days")
            .format("YYYY-MM-DD");
        } else {
          this.dataToSend.startDate = moment
            .utc(newDate)
            .subtract(this.diffDays, "days")
            .format("YYYY-MM-DD");
        }
      } else {
        this.diffDays = moment
          .utc(this.dataToSend.endDate)
          .diff(moment.utc(this.dataToSend.startDate), "days");
      }
      console.log("cdpD: this.dataToSend.startDate", this.dataToSend.startDate);
    },
  },
  watch: {
    "dataToSend.startDate": function (newCheckinDate, oldCheckinDate) {
      const checkinNewDate = new Date(newCheckinDate);
      console.log("newCheckinDate", newCheckinDate);
      this.dataToSend.startDate = moment
        .utc(this.dataToSend.startDate)
        .format("YYYY-MM-DD");
      console.log("this.dataToSend.startDate", this.dataToSend.startDate);
      if (oldCheckinDate === "" && this.dataToSend.endDate === "") {
        this.dataToSend.endDate = new Date(
          checkinNewDate.setDate(checkinNewDate.getDate() + 1)
        );
      }
      this.correctDatePickerDates(newCheckinDate);
      console.log("A", this.dataToSend.startDate);
    },
    "dataToSend.endDate": function (newCheckoutDate) {
      this.dataToSend.endDate = moment
        .utc(this.dataToSend.endDate)
        .format("YYYY-MM-DD");
      this.correctDatePickerDates(newCheckoutDate, "end");
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/external-availability/index.js